var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Delivery_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M13.5 14.001h28v28h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Delivery_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#fff",
    fillOpacity: 0,
    rx: 2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#EAE8E1",
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Delivery_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#402C22",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#Delivery_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m22.83 19.25 9.92 5.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.89 21.87v12.25l10.61 6.13 10.6-6.13V21.87l-10.6-6.12z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M17.35 22.16 27.5 28l10.15-5.84M27.5 39.66V28"
  })))));
};
export default SvgDelivery;